import axios from "axios";
import { BACKEND_API_URL } from "../constants";

/**
 * Busca todos os avisos ativos.
 * Backend retorna avisos ordenados por data de publicação (mais recentes primeiro)
 * @returns {Promise<Array>} Lista de avisos ativos
 */
export const getAvisos = async () => {
  try {
    const response = await axios.get(`${BACKEND_API_URL}/api/avisos`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: false,
    });
    return response.data; // Array de avisos
  } catch (error) {
    console.error("Erro ao buscar avisos:", error);
    throw error;
  }
};

/**
 * Busca aviso específico por ID (se o backend implementar)
 * @param {number} id - ID do aviso
 * @returns {Promise<Object>} Dados do aviso
 */
export const getAvisoById = async (id) => {
  try {
    const response = await axios.get(`${BACKEND_API_URL}/api/avisos/${id}`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: false,
    });
    return response.data;
  } catch (error) {
    console.error(`Erro ao buscar aviso ${id}:`, error);
    throw error;
  }
};

/**
 * Formata data ISO 8601 para formato brasileiro
 * @param {string} isoDate - Data no formato ISO 8601
 * @returns {string} Data formatada (ex: "04/12/2024 às 10:30")
 */
export const formatarData = (isoDate) => {
  if (!isoDate) return "";

  try {
    return new Date(isoDate).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (error) {
    console.error("Erro ao formatar data:", error);
    return isoDate;
  }
};
